import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar } from "@fortawesome/pro-solid-svg-icons";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";

import { CancelButton, NavigationButton } from "../../../../components";
import { VirtualKeyboard, LAYOUTS } from "../../../../../../components";

import "./EnterRegistration.scss";

const EnterRegistration = ({ renderLayout, onChange, onGoToCancelScreen, registrationNumber, licensePlateConfig, onConfirm, loading, onGoBack, t }) => {
  const isValidLicensePlate = registrationNumber.length >= licensePlateConfig.minLength && registrationNumber.length <= licensePlateConfig.maxLength;

  const headerButtons = [<CancelButton key={1} onClick={onGoToCancelScreen} disabled={loading} />];

  const content = (
    <div className="KioskEnterRegistrationScreen">
      <FontAwesomeIcon icon={faCar} className="EnterRegistrationHeaderIcon" />
      <div className="KioskTitle EnterRegistrationHeaderTitle">{t("kiosk_registration_number").message || "Registration Number"}</div>
      <div className="EnterRegistrationScreenRegContainer">
        <div className="reg-number-container" style={{ borderColor: licensePlateConfig.borderColor }}>
          <div className="reg-country" style={{ backgroundColor: licensePlateConfig.countryNameBackground }}>
            <div className="reg-country-text">{licensePlateConfig.plateLetter}</div>
          </div>
          <div className="reg-value-container" style={{ backgroundColor: licensePlateConfig.plateColor }}>
            <div className="reg-value-inner-container">
              {Array.from({ length: licensePlateConfig.maxLength }, (_, index) => (
                <div key={index} className="reg-number" style={{ color: licensePlateConfig.fontColor }}>
                  {registrationNumber[index] || ""}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="EnterRegistrationScreenKeyboardContainer">
        <VirtualKeyboard layout={LAYOUTS.REGISTRATION} onChange={onChange} text={registrationNumber} maxLength={licensePlateConfig.maxLength} />
      </div>
    </div>
  );

  const leftButton = <NavigationButton loading={loading} back onClick={onGoBack} />;

  const rightButton = <NavigationButton loading={loading} onClick={onConfirm} disabled={!isValidLicensePlate} />;

  return renderLayout({ headerButtons, leftButton, rightButton, content });
};

export default withRouter(withTranslation()(EnterRegistration));
